.multi-field-row(...) {
  display: grid;
  column-gap: 8px;
  grid-template-columns: @arguments;
}

.address-fields {
  display: grid;
  row-gap: 8px;
  word-break: break-word;

  &.v3-inputs {
    label {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;

      > span {
        font-style: italic;
      }
    }
  }
}

.city-state-zip {
  .multi-field-row(calc(50% - 16px), 21%, 29%);
}

.two-column-row {
  .multi-field-row(50%, calc(50% - 16px));
}

.postcode-first {
  .multi-field-row(35%, calc(65% - 8px));
}

.v2-inputs .country {
  display: grid;
  row-gap: 8px;

  label {
    font-size: 12px;
    font-weight: 400;
  }
}
